import React, { useState } from "react";
import AgentHeader from "../../components/agent-ui/AgentHeader";
import "../dev_dash/dev.css";
import { LogoutCurve, ProfileCircle, Shield } from "iconsax-react";
import { useNavigate } from "react-router-dom";
import AgentProfile from "../../components/agent-ui/AgentProfile";
import AgentSec from "../../components/agent-ui/AgentSec";

const Settings = () => {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("Profile");

  const clickTab = (item) => {
    setActiveTab(item);
  }

  const logOut = () => {
     localStorage.clear();
    navigate("/auth/signin");
  }

  return (
    <div>
      <AgentHeader header={"Settings"} />
      <div className="set_cnt">
        <div className="set_left set_bg">
          <div className={activeTab === "Profile" ? "set_tab act_sec_tab" : "set_tab"} onClick={() => clickTab("Profile")}>
            <ProfileCircle size="24" color="#1C1B1F" />
            <h3>Profile</h3>
          </div>
          <div className={activeTab === "Security" ? "set_tab act_sec_tab" : "set_tab"} onClick={() => clickTab("Security")}>
            <Shield size="24" color="#1C1B1F" />
            <h3>Security</h3>
          </div>
          <div className={"set_tab"} onClick={logOut}>
            <LogoutCurve color="#F08224" size={24} />
            <h3>Log out</h3>
          </div>
        </div>
        <div className="set_right set_bg">
          {activeTab === "Profile" && <AgentProfile />}
          {activeTab === "Security" && <AgentSec />}
        </div>
      </div>
    </div>
  );
};

export default Settings;
